import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalizedPath } from "@/hooks/useLocalizedPath";

export const Footer = () => {
  const { t } = useTranslation();
  const { buildPath } = useLocalizedPath();

  return (
    <footer className="border-t border-border py-8 mt-auto">
      <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
        <p>{t('footer.copyright')}</p>
        <div className="mt-3 flex flex-wrap justify-center gap-4 sm:gap-6">
          <Link to={buildPath('/')} className="hover:text-foreground transition-colors">
            {t('nav.home')}
          </Link>
          <Link to={buildPath('/about')} className="hover:text-foreground transition-colors">
            {t('nav.about')}
          </Link>
          <Link to={buildPath('/examples')} className="hover:text-foreground transition-colors">
            {t('nav.examples')}
          </Link>
          <Link to={buildPath('/faq')} className="hover:text-foreground transition-colors">
            {t('nav.faq')}
          </Link>
          <Link to={buildPath('/help')} className="hover:text-foreground transition-colors">
            {t('nav.help')}
          </Link>
          <Link to={buildPath('/privacy')} className="hover:text-foreground transition-colors">
            {t('nav.privacy')}
          </Link>
        </div>
        <div className="mt-3 flex flex-wrap justify-center gap-4 sm:gap-6 text-xs">
          <Link to={buildPath('/vad-ar-e-styling')} className="hover:text-foreground transition-colors">
            {t('nav.whatIsEstyling')}
          </Link>
          <Link to={buildPath('/digital-vs-traditionell-styling')} className="hover:text-foreground transition-colors">
            {t('nav.comparison')}
          </Link>
          <Link to={buildPath('/priser-e-styling')} className="hover:text-foreground transition-colors">
            {t('nav.pricingGuide')}
          </Link>
        </div>
        <div className="mt-3">
          <a href="mailto:hej@estylingstudio.se" className="hover:text-foreground transition-colors">
            hej@estylingstudio.se
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
